import type { DesignConfig } from '@src/types'

const designConfig: DesignConfig = {
  radius: '0',
  radiusSm: '0',
  radiusPill: '0',
  radiusXs: '0',
  supportedThemes: [
    'navy-green', 'slate-orange', 'forest-gold', 'charcoal-red',
    'steel-blue', 'burgundy-tan', 'teal-coral', 'navy-gold',
    'olive-amber', 'dark-mint', 'patriot-red', 'computer-anything',
  ],
  featuredThemes: ['navy-green', 'patriot-red', 'computer-anything'],
  themeDecorations: {
    'patriot-red': 'stars',
  },
}

export default designConfig
